var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainCont p-4 br6 bg-gray100 font14 fw700 gray800"},[_vm._v("\n  Medicine\n  "),_c('font-awesome-icon',{staticClass:"ml-auto",style:({ color: _vm.getPrimaryColor() }),attrs:{"size":"1x","icon":['fal', 'arrow-right']}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bb67ea8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/search/STreatment.vue
// module id = null
// module chunks = 